import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ngGridstack from 'gridstack/dist/angular'

import * as state from '../../../../../../../../state'
import * as rendering from '../../../../rendering'
import * as componentStore from '../component-store'
/**
 * Renders the referenced widget within a page
 */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.loader.Component,
    rendering.widget.Component,
  ],
  selector: 'atn-mosaic-dev-widget-frame',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component extends ngGridstack.BaseWidget {
  /** @see {@link componentStore.builder.Store} */
  public readonly store = ngCore.inject(componentStore.builder.Store)

  /** @see {@link AtnMosaicEcService.widgetsCollection} */
  private readonly _widgetsEc = ngCore.inject(
    state.mosaic.dev.widgets.Collection,
  )

  /** @see {@link state.mosaic.dev.widgets.plugins.preview.Plugin} */
  private readonly _widgetPreviewPlugin = this._widgetsEc.plugins
    .lookup(state.mosaic.dev.widgets.plugins.preview.Plugin)
    .get()

  /** @see {@link ents.core.mosaic.Widget.Ref} */
  private readonly _widgetRefSg = ngCore.computed(
    (widgetFrameLookup = this.store.widgetFrameLookupSg()) => {
      const widgetFrameId = this.widgetItem?.id
      return widgetFrameId ? widgetFrameLookup[widgetFrameId] : undefined
    },
  )
  /**
   * Retrieves the rendering configuration for the current widget frame, if
   * available.
   *
   * @see {@link ents.core.mosaic.Widget.Rendering}
   */
  // This is a temporary workaround and will be revised once the state is
  // divided by subfeatures.
  public renderingSg = ngCore.computed((widgetRef = this._widgetRefSg()) =>
    widgetRef
      ? this._widgetPreviewPlugin.feature.selectors
          .getWidgetPreview(widgetRef.widget)
          .asSignal()
      : undefined,
  )

  /** Indicates whether the referenced widget rendering is loading. */
  public loadingSg = ngCore.computed((widgetRef = this._widgetRefSg()) =>
    widgetRef
      ? this._widgetPreviewPlugin.feature.selectors
          .getWidgetLoading(widgetRef.widget)
          .asSignal()
      : undefined,
  )

  /**
   * Triggers the widget selector dialog by setting the editing widget frame ID.
   */
  public editButtonClickHandler(): void {
    const widgetFrameId = this.widgetItem?.id
    if (widgetFrameId) {
      this.store.setEditingWidget(widgetFrameId, this.renderingSg()?.alias)
    }
  }

  /**
   * Removes the current widget frame from the page builder layout.
   */
  public removeButtonClickHandler(): void {
    const widgetFrameId = this.widgetItem?.id
    if (widgetFrameId) {
      this.store.removeWidgetFrame(widgetFrameId)
    }
  }
}
